import { c as _c } from "react/compiler-runtime";
import { RatingReviews, type RatingReviewsProps } from './Reviews';
import { RatingRoundups, type RatingRoundupsProps } from './Roundups';
type NerdWalletRatingProps = ({
  variant: 'reviews';
} & RatingReviewsProps) | ({
  variant: 'roundup';
} & RatingRoundupsProps);
export function NerdWalletRating(props) {
  const $ = _c(4);
  if (props.variant === "reviews") {
    let t0;
    if ($[0] !== props) {
      t0 = <RatingReviews {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <RatingRoundups {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}